import CrudCustom from '../../../libs/custom/CrudCustom';

let AkunJenisPersedianService = new CrudCustom('/akun-jenis-persediaans');
export default AkunJenisPersedianService;
